import Heading from 'components/global/Heading'
import React, { useRef, useState } from 'react';
import Bilboard from 'assets/videos/bilboard.mp4';

const HowItWorks = () => {
    const videoRef = useRef(null);
    const [isPlaying , setIsPlaying] = useState(false);
    const [showControlBtn , setShowControlBtn] = useState(true);

    const videoHandler = () => {
        if(isPlaying){
            videoRef.current.pause();
            setIsPlaying(false);
        }else {
            setIsPlaying(true);
            videoRef.current.play();
        }
    } 

    return (
        <div className='py-12 sm:px-8 px-4'>
            <Heading 
            title='How It Works'
            />
            <div className='mt-12'>
                <div className='w-full h-full relative rounded-lg md:px-20'
                onMouseLeave={() => {
                    if(isPlaying){
                        setShowControlBtn(false);
                    }
                }}
                onMouseEnter={() => {
                    setShowControlBtn(true)
                }}
                >
                    <video 
                    src={Bilboard}
                    ref={videoRef}
                    className='rounded-lg object-cover lg:h-[500px] md:h-[400px] sm:h-[300px] h-[250px] w-full mx-auto'
                    />
                    {
                        showControlBtn && 
                        <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#fdfdfdb2] rounded-full flex items-center justify-center w-[100px] h-[100px] cursor-pointer'
                        onClick={videoHandler}
                        >
                            {
                                isPlaying
                                ? 
                                    <div className='text-4xl font-bold text-primary'>
                                        <i className="uil uil-pause"></i>
                                    </div>
                                : 
                                    <div className='text-4xl font-bold text-primary'>
                                        <i className="uil uil-play"></i>
                                    </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default HowItWorks